// extracted by mini-css-extract-plugin
export default {"card":"CardVacancyExt_card__XusV3","pseudoBtn":"CardVacancyExt_pseudoBtn__5sagN"};